import '@camiers/scss/site.scss';
import '@camiers/scss/site-editor.scss';
import '@camiers/js/bootstrap.bundle';
import { UxCpnt } from '@camiers/js/components/ux_cpnt';
import { FormCpnt } from '@camiers/js/components/form_cpnt';
import { BrochureCpnt } from '@camiers/js/components/brochure_cpnt';
import { MapCpnt } from '@camiers/js/components/map_cpnt';
import { WeatherCpnt } from '@camiers/js/components/weather_cpnt';
import { TideCpnt } from '@camiers/js/components/tide_cpnt';
import { SliderCpnt } from '@camiers/js/components/slider_cpnt';
import { EngineHomeCpnt } from '@camiers/js/components/engine_home_cpnt';

document.addEventListener( "DOMContentLoaded", function () {
    const ObjUxCpnt         = new UxCpnt();
    const ObjFormCpnt       = new FormCpnt();
    const ObjBrochureCpnt   = new BrochureCpnt();
    const ObjMapCpnt        = new MapCpnt();
    const ObjWeatherCpnt    = new WeatherCpnt();
    const ObjTideCpnt       = new TideCpnt();
    const ObjSliderCpnt     = new SliderCpnt();
    const ObjEngineJomeCpnt = new EngineHomeCpnt();
} );
